import React from "react";
import "./ImageAnalyzeList.css";
import {Accordion} from "react-bootstrap";
import ModalImage from 'react-modal-image';

const ImageAnalyzeList = ({imageAnalyzeData}) => {
    if (!imageAnalyzeData) {
        // показываем одну карточку-загрузку
        return (
            <div className="image-analyze-list">
                <div className="loader-wrapper">
                    <div className="loader"/>
                </div>
            </div>
        );
    }

    return (
        <div className="image-analyze-list">
            {/* Общие показатели */}
            <div className="image-overview mb-3">
                {imageAnalyzeData.repair !== undefined && (
                    <p>Оценка ремонта: {imageAnalyzeData.repair.toFixed(2)}</p>
                )}
                {imageAnalyzeData.furniture !== undefined && (
                    <p>Оценка меблировки: {imageAnalyzeData.furniture.toFixed(2)}</p>
                )}
            </div>

            <Accordion>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>Сырые данные</Accordion.Header>
                    <Accordion.Body>
                        {/* Сырые данные по картинкам */}
                        {imageAnalyzeData.rawData?.map((imgData, index) => (
                            <div key={index} className="image-card mb-3 d-flex align-items-start">
                                {imgData.url && (
                                    <div className="image-analyze-list-item-image">
                                        <ModalImage
                                            small={imgData.url}
                                            large={imgData.url}
                                            alt={`image-${index}`}
                                        />
                                    </div>
                                )}
                                <div className="image-info">
                                    {imgData.isInterior ? (
                                        <>
                                            <p>Интерьер: Да</p>
                                            {imgData.repairScore !== undefined && (
                                                <p>Ремонт: {imgData.repairScore.toFixed(2)}</p>
                                            )}
                                            {imgData.repairInfo !== undefined && (
                                                <p>Инфо ремонта: {imgData.repairInfo.toFixed(2)}</p>
                                            )}
                                            {imgData.furnitureScore !== undefined && (
                                                <p>Мебель: {imgData.furnitureScore.toFixed(2)}</p>
                                            )}
                                            {imgData.furnitureInfo !== undefined && (
                                                <p>Инфо мебели: {imgData.furnitureInfo.toFixed(2)}</p>
                                            )}
                                        </>
                                    ) : (
                                        <p>Интерьер: Нет</p>
                                    )}
                                </div>
                            </div>
                        ))}

                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
    );
};

export default ImageAnalyzeList;